import { useEffect } from "react";
import rules from "./TheKaiserTerms.json";

function LinkedText({ text }) {
  return text.split(/(https:\/\/[^\s]+|privacy@motopfohe\.bg)/g).map((part, index) => {
    const isURL = part.startsWith("https://");
    const isEmail = part === "privacy@motopfohe.bg";
    return isURL || isEmail ? (
      <a key={index} href={isEmail ? `mailto:${part}` : part} className="break-words text-fordBlue underline underline-offset-4 hover:opacity-80">{part}</a>
    ) : part;
  });
}

export default function TheKaiserTerms() {
  useEffect(() => {
    document.title = "Ford | Официални правила — The Kaiser";
  }, []);
  return (
    <main className="min-h-screen bg-gray-50 text-slate-800">
      <header className="bg-fordBlue px-5 py-12 text-white sm:py-16">
        <div className="mx-auto max-w-4xl">
          <p className="mb-4 text-sm uppercase tracking-widest text-white/75">Ford Bulgaria · The Kaiser</p>
          <h1 className="text-3xl font-semibold leading-tight sm:text-4xl">{rules.title}</h1>
          <p className="mt-5 text-lg leading-relaxed text-white/90">{rules.subtitle}</p>
        </div>
      </header>
      <div className="mx-auto max-w-4xl px-4 py-8 sm:px-6 sm:py-12">
        <nav aria-label="Съдържание на правилата" className="mb-8 rounded-xl border border-slate-200 bg-white p-5 sm:p-8">
          <h2 className="mb-4 text-lg font-semibold">Съдържание</h2>
          <ul className="grid gap-3 text-sm sm:grid-cols-2">
            {rules.sections.map((section, index) => <li key={section.title}><a className="text-fordBlue underline underline-offset-4" href={`#kaiser-section-${index + 1}`}>{section.title}</a></li>)}
          </ul>
        </nav>
        <article className="rounded-xl bg-white p-5 shadow-sm ring-1 ring-black/5 sm:p-10 text-base leading-7">
          {rules.sections.map((section, index) => (
            <section key={section.title} id={`kaiser-section-${index + 1}`} className="mb-10 scroll-mt-24 last:mb-0">
              <h2 className="mb-5 text-xl font-semibold leading-snug text-fordBlue">{section.title}</h2>
              <ol start={section.items[0].number} className="space-y-4 pl-6 list-decimal marker:font-semibold">
                {section.items.map(item => (
                  <li key={item.number} value={item.number} className="pl-1">
                    <LinkedText text={item.text} />
                    {item.bullets && <ul className="mt-3 space-y-2 pl-5 list-disc">{item.bullets.map(text => <li key={text}><LinkedText text={text} /></li>)}</ul>}
                  </li>
                ))}
              </ol>
            </section>
          ))}
        </article>
      </div>
    </main>
  );
}
